export const yacanConfig = {
  connection: {
    title: "YACAN-Verbindung",
    subtitle:
      "Verbinden Sie Ihr YACAN-Konto, um den Zugang Ihrer Gäste über Ihre Schlösser zu verwalten.",
    connected: "Konto verbunden",
    notConnected: "Nicht verbunden",
    info:
      "Wenn Sie auf <b>Mit YACAN verbinden</b> klicken, öffnet sich ein Fenster zur Anmeldung und Freigabe des Zugriffs. Die Verbindung wird für Ihr gesamtes Konto gespeichert und für alle Ihre Unterkünfte genutzt.",
    connect: "Mit YACAN verbinden",
    waiting: "Warten auf Autorisierung...",
    connectedTitle: "YACAN-Konto verbunden",
    authActive: "Autorisierung aktiv",
    reauthorize: "Neu autorisieren",
    reauthorizeTitle: "Erneut autorisieren",
    disconnect: "Trennen",
  },
  locks: {
    title: "Schlösser für diese Unterkunft",
    subtitle: "Wählen Sie die YACAN-Schlösser, die für <b>diese Unterkunft</b> gelten.",
    selectedCount: "{count} ausgewählt",
    noneFound: "In Ihrem YACAN-Konto wurden keine Schlösser gefunden.",
    refresh: "Aktualisieren",
    placeholder: "Schlösser auswählen…",
    summary: "{count} Schloss/Schlösser ausgewählt",
    empty: "Kein Schloss ausgewählt",
    lockFallback: "Schloss {id}",
    save: "Schlösser für diese Unterkunft speichern",
    saving: "Wird gespeichert...",
  },
  assign: {
    title: "Zuordnung (PMS)",
    subtitle: "Ordnen Sie jedes Schloss <b>Haupttür</b>, <b>Einheit</b> oder <b>Tor</b> zu.",
    assignedCount: "{count} zugeordnet",
    info:
      "Bei YACAN wird <b>der Gästezugang von YACAN verwaltet</b>, und zwar anhand der Buchung: Hier werden keine PIN erzeugt. Sobald eine Buchung bestätigt ist, wird sie automatisch mit YACAN synchronisiert.",
    lockFallback: "Schloss {id}",
    assignmentLabel: "Zuordnung",
    typeNone: "Nicht zugeordnet",
    typeCommon: "Haupttür (gemeinsam)",
    typeUnit: "Wohnungstür",
    typeGate: "Tor / Garage",
    unitLabel: "Einheit / Unterkunft",
    unitPlaceholder: "Einheit auswählen",
    unitFallback: "Einheit {id}",
    save: "Zuordnung speichern",
    saving: "Wird gespeichert...",
  },
  msg: {
    connectStartError: "Die Verbindung mit YACAN konnte nicht gestartet werden",
    popupBlocked: "Erlauben Sie Pop-up-Fenster, um sich mit YACAN zu verbinden.",
    connectError: "Fehler beim Verbinden mit YACAN",
    connectSuccess: "YACAN-Konto erfolgreich verbunden",
    connectFailed: "Verbindung mit YACAN nicht möglich",
    disconnectConfirm:
      "YACAN-Konto trennen? Buchungen werden dann nicht mehr mit YACAN synchronisiert.",
    disconnectSuccess: "YACAN-Konto getrennt",
    disconnectError: "Trennen nicht möglich",
    locksLoadError: "Die Schlösser konnten nicht geladen werden",
    locksLoadError2: "Fehler beim Laden der YACAN-Schlösser",
    selectAtLeastOne: "Wählen Sie mindestens ein Schloss.",
    lockDefaultName: "YACAN-Schloss",
    locksSaved: "Schlösser für diese Unterkunft gespeichert",
    locksSaveError: "Die Schlösser konnten nicht gespeichert werden",
    saveError: "Fehler beim Speichern",
    selectUnitForApartment: "Wählen Sie die Einheit für Schlösser vom Typ „Wohnungstür“.",
    assignSaved: "Zuordnung erfolgreich gespeichert",
    assignSaveError: "Die Zuordnung konnte nicht gespeichert werden",
    assignSaveError2: "Fehler beim Speichern der Zuordnung",
  },
};
